@if (showLdr) {
<ds-loading></ds-loading>
}
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  <app-vehicle-slider></app-vehicle-slider>
</nz-drawer>

<div class="row hdrBar">
  <div>
    <h1>Alert Dashboard<span class="tntTxt"></span></h1>
  </div>
</div>
<div class="main">
  @for (cunts of alrtcunt; track cunts) {
  <div class="row">
    <ul class="cards">
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #5b4785 0%, #3a347a 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Total Vehicles</h1>
            </div>
            <div class="row">
              <div class="col card_prt" (click)="getgrdata(1)">
                <h1 class="crdHdr_sb_sm">{{ cunts.ttl_vcls }}</h1>
                <h1 class="card_sub_title">Total Vehicles</h1>
              </div>
              <div class="col card_prt" (click)="getgrdata(6)">
                <h1 class="crdHdr_sb_sm">
                  {{ cunts.ntstr_cnt }}
                </h1>
                <h1 class="card_sub_title">Vehicles not started</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Delayed Vehicles</h1>
            </div>
            <div class="row">
              <div
                class="col card_prt"
                nz-tooltip
                nzTooltipTitle="Vehicles Late Departure From Vechile Yard"
                (click)="getgrdata(2)"
              >
                <h1 class="crdHdr_sb_sm">{{ cunts.count_dep }}</h1>
                <h1 class="card_sub_title">Late Departure</h1>
              </div>
              <div
                class="col card_prt"
                nz-tooltip
                nzTooltipTitle="Vehicles Late Arrival From Vechile Yard"
                (click)="getgrdata(3)"
              >
                <h1 class="crdHdr_sb_sm">
                  {{ cunts.count_arvl }}
                </h1>
                <h1 class="card_sub_title">Late Arrival</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%)"
        >
          <div
            class="card_content"
            nz-tooltip
            nzTooltipTitle="Route Deviated vechiles "
            (click)="getgrdata(4)"
          >
            <div class="row">
              <h1 class="crdHdr">Route Deviated</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">{{ cunts.count_rte_dvt }}</h1>
                <h1 class="card_sub_title">Vehicles</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #5b4785 0%, #3a347a 100%)"
        >
          <div
            class="card_content"
            nz-tooltip
            nzTooltipTitle="Vehicles Stoppage more than 5 minutes"
            (click)="getgrdata(5)"
          >
            <div class="row">
              <h1 class="crdHdr">Unauthorized Stoppage</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">{{ cunts.stpg_cnt }}</h1>
                <h1 class="card_sub_title">Vehicles</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  }
  <div class="row bg-wp">
    <div class="heading">
      @if (indctr==1) {
      <h1 style="color: red">Total Vehicles</h1>
      } @if (indctr==2) {
      <h1 style="color: red">Late Departure Vehicles</h1>
      } @if (indctr==3) {
      <h1 style="color: red">Late Arrival Vehicles</h1>
      } @if (indctr==4) {
      <h1 style="color: red">Route Deviated Vehicles</h1>
      } @if (indctr==5) {
      <h1 style="color: red">Unauthorized Stoppage Vehicles</h1>
      } @if (indctr==6) {
      <h1 style="color: red">Vehicles Not Started from vechicle Yard</h1>
      }
    </div>
    <div class="ds-card tbl grid">
      <app-data-grid
        class="p-8"
        style="width: 100%"
        [dataSource]="grdta"
        [legacyColumns]="tripsTrvldcolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        [exportFileName]="exportFileName"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
        <!-- -->

        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="indctr == 4 || indctr == 5 ? true : false"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoPlaybck(data, indctr)">
              @if (indctr==4) {
              <i nz-icon nzType="node-index" nzTheme="outline"></i>
              } @if (indctr==5) {
              <i nz-icon nzType="environment" nzTheme="outline"></i>
              } @if (indctr==5) {
              <p>Map</p>
              } @if (indctr==4) {
              <p>Playback</p>
              }
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <div></div>
</div>
